// extracted by mini-css-extract-plugin
export var btn = "Q_mB C_vr C_t9 d_bz d_bP d_bD d_dw";
export var full = "Q_xn d_w d_H";
export var hoverStyle = "Q_mF";
export var zoom = "Q_mG";